const messageTable = {
    'isAlphaNumeric':    'Incorrect format.',
    'isBasSerialNumber': 'BAS Serial Number format is incorrect.',
    'isChecked':         'Click checkbox to continue.',
    'isClientId':        'ServiceChannel Client ID format is incorrect.',
    'isClientSecret':    'ServiceChannel Secret format is incorrect.',
    'isCompared':        'Start value must be less than end value.',
    'isEmail':           'Incorrect email address format.',
    'isIpAddress':       'Not a valid IP Address.',
    'isNumeric':         'Not a valid number.',
    'isPassword':        'Password does not match required format.',
    'isPhoneNumber':     'Incorrect phone number format.',
    'isRequired':        'Field is required.',
    'matches':           'Values do not match.',
    'maxLength':         'Value too long.',
    'maxValue':          'Number is too large.',
    'minLength':         'Value too short.',
    'minValue':          'Number is too small.'
};

const validationMessage = brokenRule => {
    return messageTable[brokenRule[0]];
};

export default validationMessage;
